import { useEffect, useMemo, useState } from "react";
import { MdHistory } from "react-icons/md";
import { PiMagnifyingGlass } from "react-icons/pi";
import ChatHistoryTable from "./ChatHistoryTable";
import FormatDateTime from "../Functions/FormatDate";
import { GrAscend, GrDescend } from "react-icons/gr";
import { TbReload } from "react-icons/tb";
import { useNavigate, useParams } from "react-router-dom";
import PopupMex from "../Components/SavePopup";
import ChatHistoryLoader from "../Loaders/ChatHistoryLoader";
import { useLanguage } from "../Translations/LenguageContext";

const GEN_BACKEND_LINK = process.env.REACT_APP_GEN_BACKEND_LINK;

const AiChatHistoryMain = ({ 
    account_id, 
    fetchChatHistory,
    chatData,
    loadingChatData
}) => {
    const {t} = useLanguage()
    const navigate = useNavigate()
    const { org_id } = useParams()
    const [searchTerm, setSearchTerm] = useState("");
    const [sortOrder, setSortOrder] = useState("asc");

    const filteredAndSortedData = useMemo(() => {
        if (!chatData) return [];

        let result = chatData.filter((item) => {
            const term = searchTerm.toLowerCase();
            const nameMatch = item.name?.toLowerCase().includes(term);
            const messageCountMatch = item.message_count == term;
            const inputTokenMatch = item.input_tokens == term;
            const outputTokenMatch = item.output_tokens == term;
            const local_created_at = FormatDateTime(item.created_at)
            const created_at = local_created_at.toLowerCase().includes(term);

            return nameMatch || messageCountMatch || inputTokenMatch || outputTokenMatch || created_at;
        });

        result.sort((a, b) => {
            const nameA = a.created_at?.toLowerCase() || "";
            const nameB = b.created_at?.toLowerCase() || "";
            return sortOrder === "desc"
                ? nameA.localeCompare(nameB)
                : nameB.localeCompare(nameA);
        });

        return result;
    }, [chatData, searchTerm, sortOrder]);

    useEffect(() => {
        fetchChatHistory(org_id)
    }, [account_id]);


    if (loadingChatData) return <ChatHistoryLoader />;

    return (
        <div className="chat_history_cont">
            {chatData.length === 0 && (
                <div className="mainframe_item">
                    <div className="mainframe_item_header">
                        <p className="mainframe_item_title fade-in">{t.chat_history.title}</p>
                        <div className="mainframe_item_subtitle fade-in">
                            <div className="empty_org_mex_cont">
                                <p>
                                    {t.chat_history.empty_subtitle}
                                </p>
                                <div className="empty_org_img">
                                    <p className="empty_org_img_title">
                                        <i><MdHistory /></i> {t.chat_history.quest_title}
                                    </p>
                                    <p className="empty_org_img_subtitle">
                                       {t.chat_history.quest_answ}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {chatData.length > 0 && (
                <div className="chat_history_header">
                    <p className="chat_history_header_title"><MdHistory /> {t.chat_history.title}</p>
                    <div className="chat_history_header_filter">
                        <div className="filtering_mainframe">

                            <div className="filtering_mainframe_btn_cont fade-in">
                                {chatData.length > 1 && (
                                    <>
                                        <button className={`filter_btn ${sortOrder === "asc" ? "active" : ""}`} onClick={() => setSortOrder("asc")} title="A-Z">
                                            <GrAscend />
                                        </button>
                                        <button className={`filter_btn ${sortOrder === "desc" ? "active" : ""}`} onClick={() => setSortOrder("desc")} title="Z-A">
                                            <GrDescend />
                                        </button>
                                    </>
                                )}
                                <button className="filter_btn" onClick={() => fetchChatHistory(org_id)} title={t.reload}>
                                    <TbReload />
                                </button>
                            </div>
                            <div className="filter_input_cont fade-in">
                                <input
                                    className="filter_input"
                                    placeholder={t.search_filter}
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                />
                                <span className="filter_input_icon"><PiMagnifyingGlass /></span>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {chatData.length > 0 && (
                <ChatHistoryTable
                    account_id={account_id}
                    data={filteredAndSortedData}
                    fetchChatHistory={fetchChatHistory}
                />
            )}
        </div>
    )
}

export default AiChatHistoryMain